(function () {
  const header = document.querySelector('[data-site-header]');
  const toggle = document.querySelector('[data-mobile-toggle]');

  if (header && toggle) {
    toggle.addEventListener('click', function () {
      const isOpen = header.getAttribute('data-mobile-open') === 'true';
      header.setAttribute('data-mobile-open', String(!isOpen));
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  document.querySelectorAll('[data-close-mobile]').forEach(function (link) {
    link.addEventListener('click', function () {
      if (header) header.setAttribute('data-mobile-open', 'false');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });
})();

(function () {
  function initProductGalleries() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var items = gallery.querySelectorAll('[data-gallery-media]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

      if (!items.length || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var target = thumb.getAttribute('data-gallery-thumb');

          items.forEach(function (item) {
            item.classList.toggle('is-hidden', item.getAttribute('data-gallery-media') !== target);
          });

          thumbs.forEach(function (button) {
            var isActive = button === thumb;
            button.classList.toggle('is-active', isActive);
            if (isActive) {
              button.setAttribute('aria-current', 'true');
            } else {
              button.removeAttribute('aria-current');
            }
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGalleries);
  } else {
    initProductGalleries();
  }
})();
